import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

export const AuthGurad: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  if (localStorage.getItem('isLoggedIn') === 'true') {
    return true;
  } else {
    const pathname = location.pathname;
    const homePaths = ['/home', '/home/', '/'];
    if (!homePaths.includes(pathname)) {
      const returnUrl = `${pathname}${location.search}${location.hash}`;
      localStorage.setItem('xerxesState', returnUrl);
      localStorage.setItem('dashboard_name', pathname);
    }
    router.navigate(['splash']);
  }
};
